import { Audience } from 'lib/types/audience';
import { privateApi } from 'services';

const fetchLookalikeAudiences = (adAccountId: string): Promise<Audience[]> =>
    privateApi.get<Audience[]>(`facebook/graph/ad-accounts/${adAccountId}/lookalike-audiences`);

export const LookalikeAudienceGateway = {
    fetchLookalikeAudiences,
};
